import { Chip } from '@nespresso-design-system/components';
import cn from 'classnames';
import { buildProductListUrl } from '@/domain/Product.ts';
import useMarketConfig from '@/widgets/hooks/useMarketConfig.tsx';
import useRoute from '@/widgets/hooks/useRoute.tsx';
import useTranslations from '@/widgets/hooks/useTranslations.tsx';
import { trackFilterApplied } from '@/widgets/ProductList/Tracking.ts';
import { icons } from './index.ts';
import { TechnologyInfoButton } from '../../../../drawers/TechnologyInfoDrawer/TechnologyInfoDrawer.tsx';
import styles from './TechnologyList.module.scss';

export default function TechnologyList({ toggle }: { toggle?: () => void }) {
  const {
    market,
    locale,
    productTypePath,
    technology: currentTechnology
  } = useRoute();

  const { technologies } = useMarketConfig();
  const { t } = useTranslations();

  function handleTechnologyClick(
    event: MouseEvent,
    technology: string,
    url: string
  ) {
    event.preventDefault();
    trackFilterApplied('technology', technology, 'automatic');
    window.location.assign(url);
  }

  return (
    <>
      <ul class={styles.container}>
        {technologies.map((technology) => {
          const url = buildProductListUrl(
            market,
            locale,
            productTypePath,
            technology
          );
          const isCurrentTechnology = technology === currentTechnology;
          const label = t(`productList.filters.technologies.${technology}`);

          return (
            <li key={technology}>
              <Chip
                className={cn({ [styles.noInteraction]: isCurrentTechnology })} // Workaround DS comp
                aria-disabled={isCurrentTechnology} // Workaround DS comp
                aria-label={label}
                label={label}
                isActive={isCurrentTechnology}
                icon={icons[technology]}
                onClick={(e) =>
                  isCurrentTechnology
                    ? undefined
                    : handleTechnologyClick(e, technology, url)
                }
              />
            </li>
          );
        })}
      </ul>
      <TechnologyInfoButton toggle={toggle} />
    </>
  );
}
